export const copilot = {
variant: {
recommendation: "Recomendación",
action: "Acción lista",
insight: "Información",
},
dismiss: {
accessibilityLabel: "Descartar sugerencia",
},
rationale: {
label: "Por qué",
skillLabel: "Por qué esta competencia",
riskLabel: "Por qué este nivel de riesgo",
notProvided: "El modelo no proporcionó una justificación.",
},
followUp: {
kicker: "La IA está redactando…",
loadingCaption: "Eligiendo la competencia, el riesgo y la urgencia adecuados a partir de las notas de este elemento.",
successKicker: "Sugerencia de IA lista",
idleBodyWithAsset: "La IA puede redactar una orden de trabajo de seguimiento para este elemento en {{assetName}}: elige la competencia, el riesgo y la urgencia adecuados antes de que la aceptes.",
idleBodyNoAsset: "La IA puede redactar una orden de trabajo de seguimiento para este elemento: elige la competencia, el riesgo y la urgencia adecuados antes de que la aceptes.",
suggestCta_one: "Sugerir con IA · {{count}} crédito",
suggestCta_many: "Sugerir con IA · {{count}} créditos",
suggestCta_other: "Sugerir con IA · {{count}} créditos",
createCta: "Crear seguimiento",
whyExpand: "¿Por qué?",
whyCollapse: "Ocultar el motivo",
discard: "Descartar",
errorFallback: "La IA no ha podido analizar este elemento.",
fallbackCta: "Crear borrador manualmente",
skillNotMatched: "Competencia sin coincidencia",
skillNotInCatalogWarning: "La IA propuso una competencia que no está en tu catálogo. Elige una manualmente en la siguiente pantalla.",
},
riskLabel: {
low: "Riesgo bajo",
medium: "Riesgo medio",
high: "Riesgo alto",
critical: "Riesgo crítico",
},
urgencyLabel: {
standard: "Estándar",
priority: "Prioritario",
urgent: "Urgente",
},
confidence: {
high: "Confianza alta",
medium: "Confianza media",
low: "Verificar antes de aceptar",
},
dock: {
openAssistant: "Abrir asistente",
expandAssistant: "Ampliar asistente",
assistantTitle: "Asistente",
closeAssistant: "Cerrar asistente",
loadingConversation: "Cargando conversación…",
assistantEmptyTitle: "Pregunta al asistente",
assistantEmptyBody: "Utilice el mismo asistente operativo desde el interior de este panel lateral.",
actorYou: "Tú",
actorAssistant: "Asistente",
dictationInserting: "Insertando transcripción…",
dictationFinishing: "Finalizando dictado…",
dictationHeard: "Escuchado: {{transcript}}",
dictationListening: "Escuchando…",
messageInputLabel: "Mensaje al asistente",
messagePlaceholder: "Haz una pregunta o dile al asistente qué hacer",
stopDictation: "Detener dictado",
dictateMessage: "Dictar mensaje",
startNewThread: "Iniciar un nuevo hilo con el asistente",
newThread: "Nuevo hilo",
sendAssistantMessage: "Enviar mensaje al asistente",
sending: "Enviando...",
send: "Enviar",
noSuggestionsWithAsk: "No hay sugerencias en este momento. Pregunta al asistente aquí abajo.",
noSuggestions: "No hay sugerencias en este momento.",
openAssistantInput: "Abrir entrada del asistente",
askPlaceholder: "Pregunta al asistente…",
dictateAssistantMessage: "Dictar mensaje del asistente",
},
photoFixSuggestion: {
idleHeaderText: "Utilice la foto para redactar una solución",
idleHint: "La IA mira la foto y las notas del inspector para sugerir un título, alcance, prioridad y coste aproximado.",
suggestA11y_one: "Sugerir solución a partir de la foto. Cuesta {{count}} crédito.",
suggestA11y_other: "Sugerir solución a partir de la foto. Cuesta {{count}} créditos.",
suggestButton_one: "Sugerir solución a partir de la foto ({{count}} crédito)",
suggestButton_other: "Sugerir solución a partir de la foto ({{count}} créditos)",
loadingStage1: "Leyendo la foto…",
loadingStage2: "Detectando la posible falla...",
loadingStage3: "Redactando la solución...",
loadingStage4: "Ya casi llegamos...",
loadingHint: "Mirar la foto lleva unos segundos; puedes seguir trabajando.",
retryA11y: "Reintentar sugerencia de solución",
tryAgain: "Intentar de nuevo",
headerEyebrow: "Recomendación de solución con IA · {{pct}}% de confianza",
priorityHigh: "Alta",
priorityMedium: "Media",
priorityLow: "Baja",
priorityChip: "Prioridad {{level}}",
safetyCallouts: "Avisos de seguridad",
useThisFixA11y: "Utilice esta solución como borrador de la orden de trabajo",
useThisFix: "Utilice esta solución",
discardA11y: "Descartar esta sugerencia",
discard: "Descartar",
suggestA11y_many: "Sugerir solución a partir de la foto. Cuesta {{count}} créditos.",
suggestButton_many: "Sugerir solución a partir de la foto ({{count}} créditos)",
},
};
